<script lang="ts">
    export let errorDetails;
</script>

<error class="noRestConnectionError">
    <img src="/assets/error.gif" alt="">
    <section class="errorDetails">
        <h3>Problem z połączeniem</h3>
        <small>REST API jest teraz niedostępne ze względu na problemy z serwerem, lub posiadasz problemy z połączeniem. Nie możemy pobrać danych wymaganych do działania apliakcji. Daj nam znać o zaistniałym błędzie, przekaż jego kod: <span class="errorCode">{errorDetails}</span></small>
    </section>
</error>

<style lang="scss">
    .noRestConnectionError {
        display: block;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: 100vh;
        width: 100vw;
        background-color: #f45b69;
        text-align: center;

        img {
            height: 200px;
            margin-bottom: 1rem;
        }

        .errorDetails {
            color: white;
            padding: 0 3.5rem;
            
            h3 {
                font-size: 2rem;
                margin-bottom: .5rem;
            }

            small {
                font-size: .7rem;

                .errorCode {
                    font-weight: bold;
                }
            }
        }
    }
</style>